import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiHeart, FiShield, FiUsers, FiStar, FiGlobe, FiZap, FiArrowRight, FiAward, FiTrendingUp, FiCheck, FiLinkedin, FiMail } from 'react-icons/fi';

const C = {
  rose: '#e3425c', roseLight: 'rgba(227,66,92,0.08)', roseDeep: '#c94d5c',
  gold: '#d4a853', goldLight: 'rgba(212,168,83,0.12)', goldDark: '#b8923e',
  dark: '#1c1c1e', darkLight: '#3a3a3c', cream: '#f7f7f8', creamDark: '#ebebed',
  white: '#ffffff', gray: '#8e8e93', grayLight: '#aeaeb2',
  saGreen: '#007A4D', saYellow: '#FFB612', saRed: '#DE3831', saBlue: '#002395',
};

export default function About() {
  return (
    <div style={{ minHeight: '100vh', background: C.cream, fontFamily: 'Inter, -apple-system, sans-serif' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Inter:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; }
      `}</style>

      {/* Nav */}
      <nav style={{ position: 'sticky', top: 0, zIndex: 100, background: 'rgba(255,255,255,0.97)', backdropFilter: 'blur(20px)', borderBottom: `1px solid ${C.creamDark}`, padding: '14px 0' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to='/' style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: C.dark }}>
            <FiArrowLeft size={16} />
            <img src="/ggr-logo-deck.png" alt='GGR' style={{ height: '50px', width: 'auto' }} />
          </Link>
          <Link to='/register' style={{ padding: '10px 22px', borderRadius: '8px', background: C.rose, color: C.white, textDecoration: 'none', fontSize: '13px', fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>
            Get Started
          </Link>
        </div>
      </nav>

      {/* Hero Banner */}
      <section style={{ background: `linear-gradient(135deg, ${C.rose} 0%, ${C.roseDeep} 100%)`, padding: '80px 0', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: '-30%', right: '-10%', width: '600px', height: '600px', borderRadius: '50%', background: 'rgba(255,255,255,0.04)' }} />
          <div style={{ position: 'absolute', bottom: '-20%', left: '-5%', width: '400px', height: '400px', borderRadius: '50%', background: 'rgba(212,168,83,0.1)' }} />
        </div>
        <div style={{ maxWidth: '720px', margin: '0 auto', padding: '0 28px', textAlign: 'center', position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '20px' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 16px', borderRadius: '20px', background: 'rgba(255,255,255,0.15)', color: C.white, fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase' }}>
              <FiHeart size={12} /> Our Story
            </div>
          </div>
          <h1 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: 'clamp(36px, 5vw, 56px)', fontWeight: 700, color: C.white, lineHeight: 1.15, marginBottom: '20px' }}>
            Making celebrations<br /><span style={{ color: C.gold }}>effortless</span>
          </h1>
          <p style={{ fontSize: '17px', color: 'rgba(255,255,255,0.88)', lineHeight: 1.8, maxWidth: '540px', margin: '0 auto' }}>
            Grand Gather Registry was born from a simple truth — planning celebrations in South Africa shouldn't be this hard. We set out to change that.
          </p>
        </div>
      </section>

      {/* AI Tech Stack — KEY for Google verification */}
      <section style={{ padding: '60px 0', background: C.cream }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 28px' }}>
          <div style={{
            padding: '36px 40px',
            background: `linear-gradient(135deg, ${C.roseLight}, #FFF0F1)`,
            borderRadius: '18px',
            border: `2px solid ${C.rose}`,
            textAlign: 'center',
          }}>
            <h3 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: '22px', color: C.dark, marginBottom: '12px' }}>
              <FiZap size={20} style={{ marginRight: '6px', verticalAlign: 'middle' }} />
              AI-First Startup — Powered by Google Cloud
            </h3>
            <p style={{ fontSize: '15px', color: '#555', lineHeight: 1.8, maxWidth: '600px', margin: '0 auto' }}>
              Grand Gather Registry is an <strong>AI-first technology startup</strong> utilizing <strong>Google Cloud Vertex AI</strong> and <strong>Gemini Pro</strong> to power our AI assistant <strong>GiGi</strong>. GiGi provides multilingual event planning support across English, Zulu, Sotho, and Afrikaans — generating AI-powered invitations, vendor recommendations, guest management insights, and smart event timelines. Our integration with Google Cloud's AI infrastructure enables us to deliver cutting-edge event planning tools tailored specifically for South African celebrations.
            </p>
            <p style={{ marginTop: '12px', fontSize: '13px', color: '#888' }}>
              Google Cloud Platform &bull; Vertex AI &bull; Gemini Pro &bull; Cloud Run &bull; Cloud SQL
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section style={{ padding: '70px 0', background: C.white }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 28px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px' }}>
          <div style={{ padding: '40px', background: C.roseLight, borderRadius: '20px', border: `1px solid rgba(227,66,92,0.12)` }}>
            <div style={{ width: '52px', height: '52px', borderRadius: '14px', background: C.rose, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.white, marginBottom: '20px', fontSize: '22px' }}><FiStar /></div>
            <h3 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: '24px', marginBottom: '12px', color: C.dark }}>Our Mission</h3>
            <p style={{ fontSize: '15px', color: '#666', lineHeight: 1.8 }}>
              To empower every host — from a bride planning her white wedding to a family organizing a lobola celebration — with tools that make event planning joyful, not stressful. We believe every gathering deserves to be celebrated beautifully.
            </p>
          </div>
          <div style={{ padding: '40px', background: C.goldLight, borderRadius: '20px', border: `1px solid rgba(212,168,83,0.15)` }}>
            <div style={{ width: '52px', height: '52px', borderRadius: '14px', background: C.gold, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.white, marginBottom: '20px', fontSize: '22px' }}><FiGlobe /></div>
            <h3 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: '24px', marginBottom: '12px', color: C.dark }}>Our Vision</h3>
            <p style={{ fontSize: '15px', color: '#666', lineHeight: 1.8 }}>
              To become South Africa's go-to celebration platform — connecting hosts with trusted vendors, simplifying gifting, and bringing communities together through unforgettable events.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section style={{ padding: '70px 0', background: C.white }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 28px' }}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h2 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: 'clamp(28px, 3.5vw, 40px)', fontWeight: 700, color: C.dark, marginBottom: '10px' }}>What We Stand For</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '24px' }}>
            {[
              { icon: <FiShield size={22} />, title: 'Trust & Safety', desc: 'Verified vendors, secure payments, and data protection for every user', color: C.rose },
              { icon: <FiUsers size={22} />, title: 'Community First', desc: 'Built for real SA celebrations — lobola, umembeso, weddings, birthdays and more', color: C.gold },
              { icon: <FiZap size={22} />, title: 'Simplicity', desc: 'Powerful tools that anyone can use, no tech expertise needed', color: C.rose },
              { icon: <FiHeart size={22} />, title: 'Ubuntu', desc: 'We believe every celebration is an act of togetherness that deserves care', color: C.gold },
            ].map((v, i) => (
              <div key={i} style={{ padding: '28px', background: C.cream, borderRadius: '16px', border: `1px solid ${C.creamDark}`, textAlign: 'center', transition: 'transform 0.2s' }}>
                <div style={{ width: '52px', height: '52px', borderRadius: '50%', background: `${v.color}15`, color: v.color, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>{v.icon}</div>
                <h4 style={{ fontSize: '16px', fontWeight: 700, marginBottom: '8px', color: C.dark }}>{v.title}</h4>
                <p style={{ fontSize: '14px', color: '#888', lineHeight: 1.6 }}>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Meet the Founder */}
      <section style={{ padding: '70px 0', background: C.cream }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 28px' }}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 16px', borderRadius: '20px', background: C.roseLight, color: C.rose, fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '14px' }}>
              <FiUsers size={12} /> Leadership
            </div>
            <h2 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: 'clamp(28px, 3.5vw, 40px)', fontWeight: 700, color: C.dark }}>
              Meet the <span style={{ color: C.rose }}>Founder</span>
            </h2>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{
              maxWidth: '700px', width: '100%',
              background: C.white, borderRadius: '24px',
              padding: '44px',
              boxShadow: `0 8px 40px rgba(0,0,0,0.06)`,
              border: `1px solid ${C.creamDark}`,
              display: 'flex', gap: '32px', alignItems: 'center',
              flexWrap: 'wrap', justifyContent: 'center'
            }}>
              {/* Founder Photo */}
              <div style={{
                width: '160px', height: '160px', borderRadius: '50%',
                overflow: 'hidden',
                flexShrink: 0,
                boxShadow: `0 6px 24px ${C.rose}30`,
                border: `3px solid ${C.rose}20`
              }}>
                <img
                  src="/Boitumelo_Mosaka.png"
                  alt="Boitumelo Mosaka — Founder &amp; Chief Visionary Officer"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 20%' }}
                />
              </div>

              {/* Founder Info */}
              <div style={{ flex: 1, minWidth: '260px' }}>
                <h3 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: '24px', fontWeight: 700, color: C.dark, marginBottom: '4px' }}>
                  Boitumelo Mosaka
                </h3>
                <p style={{ fontSize: '14px', color: C.rose, fontWeight: 600, marginBottom: '16px', letterSpacing: '0.3px' }}>
                  Founder &amp; Innovation Lead
                </p>
                <p style={{ fontSize: '14px', color: '#666', lineHeight: 1.7, marginBottom: '20px' }}>
                  A South African entrepreneur passionate about technology, community, and celebration. Boitumelo founded Grand Gather Registry to simplify event planning across South Africa's diverse cultures — making it effortless for hosts to plan weddings, lobola celebrations, birthdays, and more, while connecting communities through shared moments of joy.
                </p>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  <a
                    href="https://www.linkedin.com/in/boitumelo-mosaka-974666350/"
                    target="_blank" rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex', alignItems: 'center', gap: '8px',
                      padding: '10px 20px', borderRadius: '10px',
                      background: '#0077B5', color: C.white,
                      textDecoration: 'none', fontSize: '13px', fontWeight: 600,
                      transition: 'opacity 0.2s'
                    }}
                  >
                    <FiLinkedin size={16} /> Connect on LinkedIn
                  </a>
                  <a
                    href="mailto:info@grandgatherregistry.co.za"
                    style={{
                      display: 'inline-flex', alignItems: 'center', gap: '8px',
                      padding: '10px 20px', borderRadius: '10px',
                      background: C.cream, color: C.dark,
                      textDecoration: 'none', fontSize: '13px', fontWeight: 600,
                      border: `1px solid ${C.creamDark}`,
                      transition: 'background 0.2s'
                    }}
                  >
                    <FiMail size={16} /> Email
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Meet the Team */}
      <section style={{ padding: '70px 0', background: C.white }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 28px' }}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 16px', borderRadius: '20px', background: C.roseLight, color: C.rose, fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '14px' }}>
              <FiUsers size={12} /> Our Team
            </div>
            <h2 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: 'clamp(28px, 3.5vw, 40px)', fontWeight: 700, color: C.dark }}>
              Meet the <span style={{ color: C.rose }}>Team</span>
            </h2>
            <p style={{ fontSize: '15px', color: C.gray, marginTop: '8px' }}>The passionate people behind Grand Gather Registry</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '28px' }}>
            {[
              {
                name: 'Boitumelo Mosaka',
                role: 'Founder & Innovation Lead',
                img: '/Boitumelo_Mosaka.png',
                bio: 'Responsible for concept development, product vision, user experience design, and ecosystem partnerships. Boitumelo is the driving force behind Grand Gather Registry, ensuring the platform empowers hosts across South Africa.'
              },
              {
                name: 'Bongani Melembe',
                role: 'Head of Development',
                img: '/Bongani_pic-removebg-preview.png',
                bio: 'Responsible for the technical development of the platform, including system architecture, backend development, platform infrastructure and integration of digital technologies required for the Grand Gather Registry ecosystem.'
              },
              {
                name: 'Siyanda Gazu',
                role: 'Project Manager',
                img: '/Siyanda_Gazu2.png',
                bio: 'Responsible for project coordination, development timelines, and ensuring the successful delivery of the platform. Siyanda brings valuable experience in technology project management and execution.'
              },
              {
                name: 'Thabiso Mabiletja',
                role: 'Front-End Developer',
                img: '/Thabiso_Mabiletja.png',
                bio: 'Responsible for developing the user interface and front-end functionality of the platform, ensuring the platform is user-friendly, responsive and accessible across web and mobile devices.'
              }
            ].map((member, i) => (
              <div key={i} style={{
                background: C.cream, borderRadius: '18px', padding: '36px 24px', textAlign: 'center',
                border: `1px solid ${C.creamDark}`, transition: 'all 0.3s'
              }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = `0 12px 32px rgba(0,0,0,0.1)`; }}
                onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}
              >
                <div style={{
                  width: '120px', height: '120px', borderRadius: '50%', overflow: 'hidden',
                  margin: '0 auto 18px',
                  border: `3px solid ${C.rose}20`,
                  boxShadow: `0 4px 16px ${C.rose}15`
                }}>
                  <img src={member.img} alt={`${member.name} — ${member.role}`}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 20%' }} />
                </div>
                <h3 style={{ fontSize: '17px', fontWeight: 700, color: C.dark, marginBottom: '4px' }}>{member.name}</h3>
                <p style={{ fontSize: '13px', color: C.rose, fontWeight: 600, marginBottom: '10px' }}>{member.role}</p>
                <p style={{ fontSize: '13px', color: '#666', lineHeight: 1.7 }}>{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works — Timeline */}
      <section style={{ padding: '70px 0', background: C.white }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 28px' }}>
          <div style={{ textAlign: 'center', marginBottom: '56px' }}>
            <h2 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: 'clamp(28px, 3.5vw, 40px)', fontWeight: 700, color: C.dark, marginBottom: '10px' }}>
              How It <span style={{ color: C.rose }}>Works</span>
            </h2>
            <p style={{ fontSize: '15px', color: C.gray }}>Get your event up and running in four simple steps</p>
          </div>

          <div style={{ position: 'relative' }}>
            {/* Vertical line */}
            <div style={{ position: 'absolute', left: '50%', top: 0, bottom: 0, width: '2px', background: C.creamDark, transform: 'translateX(-50%)', display: 'none' }} />

            <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
              {[
                { step: '01', title: 'Create Your Event', desc: 'Sign up free and choose your event type — wedding, lobola, birthday, or any celebration.', color: C.rose },
                { step: '02', title: 'Design & Invite', desc: 'Use our AI-powered invitation designer or upload your own. Send via WhatsApp, email, or SMS.', color: C.gold },
                { step: '03', title: 'Manage & Track', desc: 'Track RSVPs in real time, manage your guest list, and coordinate with vendors.', color: C.rose },
                { step: '04', title: 'Celebrate!', desc: 'Set up your gift registry, let guests contribute to your special day, and enjoy the event.', color: C.gold },
              ].map((item, i) => (
                <div key={i} style={{ display: 'flex', gap: '24px', alignItems: 'flex-start' }}>
                  <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: `linear-gradient(135deg, ${item.color}, ${item.color}cc)`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.white, fontSize: '18px', fontWeight: 700, fontFamily: 'Playfair Display, Georgia, serif', boxShadow: `0 4px 12px ${item.color}30` }}>
                      {item.step}
                    </div>
                    {i < 3 && <div style={{ width: '2px', flex: 1, minHeight: '40px', background: `linear-gradient(180deg, ${item.color}40, ${C.creamDark})` }} />}
                  </div>
                  <div style={{ paddingTop: '6px', flex: 1 }}>
                    <h4 style={{ fontSize: '18px', fontWeight: 700, color: C.dark, marginBottom: '6px' }}>{item.title}</h4>
                    <p style={{ fontSize: '14px', color: C.gray, lineHeight: 1.7 }}>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Recognition & Achievements */}
      <section style={{ padding: '70px 0', background: C.white }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 28px' }}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 16px', borderRadius: '20px', background: C.goldLight, color: C.goldDark, fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '14px' }}>
              <FiAward size={12} /> Recognition
            </div>
            <h2 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: 'clamp(28px, 3.5vw, 40px)', fontWeight: 700, color: C.dark }}>
              Awards & <span style={{ color: C.rose }}>Recognition</span>
            </h2>
            <p style={{ fontSize: '15px', color: C.gray, marginTop: '8px' }}>Recognised for innovation in South Africa's digital landscape</p>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', gap: '64px', flexWrap: 'wrap' }}>
            {/* SAFT Trophy */}
            <div style={{ textAlign: 'center', maxWidth: '260px' }}>
              <svg width='100' height='120' viewBox='0 0 100 120' fill='none' xmlns='http://www.w3.org/2000/svg' style={{ marginBottom: '20px', filter: `drop-shadow(0 4px 12px ${C.gold}30)` }}>
                <path d='M30 15 H70 L65 65 Q62 80 50 85 Q38 80 35 65 Z' fill='url(#goldGrad2)' stroke='#B8941F' strokeWidth='1.5'/>
                <path d='M30 20 Q10 20 10 40 Q10 55 25 55' fill='none' stroke='url(#goldGrad2)' strokeWidth='4' strokeLinecap='round'/>
                <path d='M70 20 Q90 20 90 40 Q90 55 75 55' fill='none' stroke='url(#goldGrad2)' strokeWidth='4' strokeLinecap='round'/>
                <ellipse cx='50' cy='15' rx='21' ry='5' fill='#E8D59A' stroke='#B8941F' strokeWidth='1'/>
                <rect x='46' y='85' width='8' height='14' rx='2' fill='url(#goldGrad2)'/>
                <ellipse cx='50' cy='103' rx='22' ry='6' fill='url(#goldGrad2)' stroke='#B8941F' strokeWidth='1'/>
                <rect x='32' y='100' width='36' height='8' rx='2' fill='url(#goldGrad2)' stroke='#B8941F' strokeWidth='0.5'/>
                <polygon points='50,30 53,40 63,40 55,46 58,56 50,50 42,56 45,46 37,40 47,40' fill='#FFF8E1' opacity='0.6'/>
                <text x='50' y='115' textAnchor='middle' fontSize='8' fontWeight='700' fill='#B8941F' fontFamily='Inter, sans-serif'>TOP 3</text>
                <defs>
                  <linearGradient id='goldGrad2' x1='0' y1='0' x2='1' y2='1'>
                    <stop offset='0%' stopColor='#E8D59A'/><stop offset='50%' stopColor='#C9A84C'/><stop offset='100%' stopColor='#B8941F'/>
                  </linearGradient>
                </defs>
              </svg>
              <h3 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: '20px', color: C.dark, marginBottom: '6px' }}>SAFT Awards 2025</h3>
              <p style={{ fontSize: '11px', color: C.gold, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Most Innovative Idea</p>
              <p style={{ fontSize: '13px', color: '#888', lineHeight: 1.6 }}>Top 3 at the South African Future Trust Awards for pioneering digital event management in Africa.</p>
            </div>

            {/* FNB Medal */}
            <div style={{ textAlign: 'center', maxWidth: '260px' }}>
              <svg width='100' height='120' viewBox='0 0 100 120' fill='none' xmlns='http://www.w3.org/2000/svg' style={{ marginBottom: '20px', filter: `drop-shadow(0 4px 12px ${C.rose}25)` }}>
                <path d='M35 0 L25 45 L50 35 L75 45 L65 0' fill='url(#ribbonGrad2)'/>
                <path d='M35 0 L50 10 L65 0' fill='none' stroke='white' strokeWidth='0.5' opacity='0.3'/>
                <circle cx='50' cy='68' r='34' fill='url(#medalGrad2)' stroke='#D13A4F' strokeWidth='2'/>
                <circle cx='50' cy='68' r='28' fill='none' stroke='#F8E0E3' strokeWidth='1.5' opacity='0.5'/>
                <circle cx='50' cy='68' r='24' fill='url(#medalInner2)'/>
                <polygon points='50,50 54,60 64,60 56,66 59,76 50,70 41,76 44,66 36,60 46,60' fill='#FFF0F2' opacity='0.7'/>
                <text x='50' y='90' textAnchor='middle' fontSize='8' fontWeight='700' fill='white' opacity='0.8' fontFamily='Inter, sans-serif'>TOP 10</text>
                <defs>
                  <linearGradient id='ribbonGrad2' x1='0' y1='0' x2='0' y2='1'>
                    <stop offset='0%' stopColor='#E3425C'/><stop offset='100%' stopColor='#D13A4F'/>
                  </linearGradient>
                  <linearGradient id='medalGrad2' x1='0' y1='0' x2='1' y2='1'>
                    <stop offset='0%' stopColor='#E3425C'/><stop offset='50%' stopColor='#D13A4F'/><stop offset='100%' stopColor='#A83A4A'/>
                  </linearGradient>
                  <linearGradient id='medalInner2' x1='0' y1='0' x2='1' y2='1'>
                    <stop offset='0%' stopColor='#D13A4F'/><stop offset='100%' stopColor='#A83A4A'/>
                  </linearGradient>
                </defs>
              </svg>
              <h3 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: '20px', color: C.dark, marginBottom: '6px' }}>FNB App of the Year 2025</h3>
              <p style={{ fontSize: '11px', color: C.rose, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Innovative Category</p>
              <p style={{ fontSize: '13px', color: '#888', lineHeight: 1.6 }}>Top 10 at the FNB App of the Year Awards, recognised as one of South Africa's most promising digital platforms.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Proudly South African */}
      <section style={{ background: C.white }}>
        {/* Ndebele SA flag pattern band */}
        <div style={{ width: '100%', overflow: 'hidden' }}>
          <svg viewBox='0 0 1200 100' preserveAspectRatio='none' xmlns='http://www.w3.org/2000/svg' style={{ display: 'block', width: '100%', height: 'auto' }}>
            <rect width='1200' height='100' fill={C.saGreen}/>
            {Array.from({length: 10}).map((_, i) => {
              const x = i * 120 + 60;
              return (
                <g key={i}>
                  <polygon points={`${x},5 ${x+55},50 ${x},95 ${x-55},50`} fill='none' stroke={C.saYellow} strokeWidth='3'/>
                  <polygon points={`${x},12 ${x+44},50 ${x},88 ${x-44},50`} fill='#000000'/>
                  <polygon points={`${x},18 ${x+36},50 ${x},82 ${x-36},50`} fill='none' stroke={C.saGreen} strokeWidth='2'/>
                  <polygon points={`${x},24 ${x+28},50 ${x},76 ${x-28},50`} fill={i % 2 === 0 ? C.saRed : C.saBlue}/>
                  <polygon points={`${x},36 ${x+14},50 ${x},64 ${x-14},50`} fill='white' opacity='0.15'/>
                  <polygon points={`${x},44 ${x+8},50 ${x},56 ${x-8},50`} fill={C.saYellow} opacity='0.5'/>
                </g>
              );
            })}
          </svg>
        </div>

        {/* Dark section */}
        <div style={{ background: C.dark, padding: '64px 0 72px', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', inset: 0, opacity: 0.02, background: `linear-gradient(45deg, white 25%, transparent 25%, transparent 75%, white 75%)`, backgroundSize: '60px 60px' }} />
          <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 44px', textAlign: 'center', position: 'relative', zIndex: 2 }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '6px 16px', borderRadius: '20px', background: `${C.saYellow}18`, color: C.saYellow, fontSize: '11px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '20px' }}>
              <img src="/sa-flag.png" alt="SA Flag" style={{ height: '19px', width: 'auto', flexShrink: 0, verticalAlign: 'middle' }} />
              Proudly South African
            </div>
            <h2 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: 'clamp(28px, 3.5vw, 40px)', fontWeight: 700, color: C.white, marginBottom: '16px', lineHeight: 1.2 }}>
              Built by South Africans,<br /><span style={{ color: C.saYellow }}>for South Africans</span>
            </h2>
            <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.5)', lineHeight: 1.8, maxWidth: '560px', margin: '0 auto 28px' }}>
              We understand the nuances of our celebrations — from the joy of a Tswana wedding to the elegance of a Zulu umemulo. Our team is passionate about making every event special.
            </p>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '36px' }}>
              {[
                { label: 'Weddings', color: C.saRed },
                { label: 'Lobola', color: C.saYellow },
                { label: 'Umemulo', color: C.saGreen },
                { label: 'Umembeso', color: C.saBlue },
                { label: 'Birthdays', color: C.saRed },
                { label: 'Baby Showers', color: C.saGreen },
                { label: 'Funerals', color: '#555' },
              ].map((c, i) => (
                <span key={i} style={{ padding: '7px 14px', borderRadius: '8px', background: `${c.color}18`, border: `1px solid ${c.color}30`, color: c.color, fontSize: '12px', fontWeight: 600 }}>
                  {c.label}
                </span>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to='/register' style={{ padding: '14px 28px', borderRadius: '10px', background: C.rose, color: C.white, textDecoration: 'none', fontWeight: 600, fontSize: '15px', display: 'inline-flex', alignItems: 'center', gap: '8px', boxShadow: `0 4px 16px ${C.rose}40` }}>
                Start Planning <FiArrowRight size={16} />
              </Link>
              <Link to='/contact' style={{ padding: '14px 28px', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.15)', color: C.white, textDecoration: 'none', fontWeight: 600, fontSize: '15px' }}>
                Get in Touch
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Ndebele band (mirrored) */}
        <div style={{ width: '100%', overflow: 'hidden', transform: 'scaleY(-1)' }}>
          <svg viewBox='0 0 1200 100' preserveAspectRatio='none' xmlns='http://www.w3.org/2000/svg' style={{ display: 'block', width: '100%', height: 'auto' }}>
            <rect width='1200' height='100' fill={C.saGreen}/>
            {Array.from({length: 10}).map((_, i) => {
              const x = i * 120 + 60;
              return (
                <g key={i}>
                  <polygon points={`${x},5 ${x+55},50 ${x},95 ${x-55},50`} fill='none' stroke={C.saYellow} strokeWidth='3'/>
                  <polygon points={`${x},12 ${x+44},50 ${x},88 ${x-44},50`} fill='#000000'/>
                  <polygon points={`${x},18 ${x+36},50 ${x},82 ${x-36},50`} fill='none' stroke={C.saGreen} strokeWidth='2'/>
                  <polygon points={`${x},24 ${x+28},50 ${x},76 ${x-28},50`} fill={i % 2 === 0 ? C.saBlue : C.saRed}/>
                  <polygon points={`${x},36 ${x+14},50 ${x},64 ${x-14},50`} fill='white' opacity='0.15'/>
                  <polygon points={`${x},44 ${x+8},50 ${x},56 ${x-8},50`} fill={C.saYellow} opacity='0.5'/>
                </g>
              );
            })}
          </svg>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ padding: '60px 0 40px', background: C.dark, borderTop: '1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 28px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px', marginBottom: '40px' }}>
            {/* Logo & Description */}
            <div style={{ maxWidth: '300px' }}>
              <img
                src="/ggr-logo-deck.png"
                alt="GGR"
                style={{ height: '70px', width: 'auto', filter: 'brightness(0) invert(1)', marginBottom: '16px' }}
              />
              <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)', lineHeight: 1.7, marginBottom: '16px' }}>
                South Africa's AI-powered event management platform. Plan weddings, lobola, birthdays and more with GiGi.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 style={{ fontSize: '14px', fontWeight: 700, color: C.white, marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '1px' }}>Product</h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {['Features', 'How It Works', 'Pricing', 'Vendors'].map((item) => (
                  <li key={item} style={{ marginBottom: '10px' }}>
                    <Link to={`/#${item.toLowerCase().replace(' ', '-')}`} style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)', textDecoration: 'none', transition: 'color 0.2s' }}>{item}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 style={{ fontSize: '14px', fontWeight: 700, color: C.white, marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '1px' }}>Company</h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {['About', 'Contact', 'Careers', 'Partnerships'].map((item) => (
                  <li key={item} style={{ marginBottom: '10px' }}>
                    <Link to={`/${item.toLowerCase()}`} style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)', textDecoration: 'none', transition: 'color 0.2s' }}>{item}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h4 style={{ fontSize: '14px', fontWeight: 700, color: C.white, marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '1px' }}>Legal</h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {['Privacy Policy', 'Terms of Service', 'FAQs'].map((item) => (
                  <li key={item} style={{ marginBottom: '10px' }}>
                    {item === 'FAQs' ? (
                      <a href="/FAQs.pdf" download style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)', textDecoration: 'none', transition: 'color 0.2s' }}>{item}</a>
                    ) : (
                      <Link to={`/${item.toLowerCase().replace(' ', '-')}`} style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)', textDecoration: 'none', transition: 'color 0.2s' }}>{item}</Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div style={{ paddingTop: '24px', borderTop: '1px solid rgba(255,255,255,0.08)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
            <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.35)', margin: 0 }}>
              &copy; 2025–2026 Grand Gather Registry (Pty) Ltd. All rights reserved. Made with love in South Africa.
            </p>
            <div style={{ display: 'flex', gap: '16px' }}>
              {[
                { name: 'Facebook', href: 'https://www.facebook.com/share/19hErECMhz/' },
                { name: 'Instagram', href: 'https://www.instagram.com/grand_gather_registry' },
                { name: 'TikTok', href: 'https://www.tiktok.com/@grand.gather.regi' },
                { name: 'X', href: 'https://x.com/grand_gather' },
              ].map((social) => (
                <a key={social.name} href={social.href} target="_blank" rel="noopener noreferrer" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>
                  {social.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}